import React from 'react'
import { MenuButton, Icon } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const ExcludeFromHeyLoyalty = ({ order, refetch, readOnly }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    fetch(`/rest/v1/order/${order.uid}`, {
      method: 'PUT',
      body: JSON.stringify({
        hl_exclude: !(!!(+order.hl_exclude))
      }) 
    })
    .then((response) => response.json())
    .then((response) => {
        if (!!(+response.hl_exclude)) {
          toastr.success(formatMessage(messages.excluded))
        } else {
          toastr.success(formatMessage(messages.included))
        }
        refetch()
      })
      .catch((error) => window.alert(error))
  }

  return (
    <Menu.Item key='ExcludeFromHeyLoyalty' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          <div className="flex justify-between items-center space-x-4">
            <span>{formatMessage(messages.title)}</span>
            <Icon icon={!!(+order.hl_exclude) ? 'check-square' : 'square'} />
          </div>
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default ExcludeFromHeyLoyalty
